import { useEffect, useState } from 'react'
import { GetAnnualPlanOptions } from '../../../services/AnnualPlanService'
import { AnnualPlanOptionCard } from './AnnualPlanOptionCard'
import { CircularProgress, Stack } from '@mui/material'
import type { AnnualPlanOption } from '../../../models/requestObjects/AnnualPlanResponseObjects'
import { handleApiResponse } from '../../../utils/apiHelpers'

interface AnnualPlanListProps {
  rcnId: number
}

export function AnnualPlanList (props: AnnualPlanListProps): JSX.Element {
  const [loading, setLoading] = useState(true)

  const [annualPlans, setAnnualPlans] = useState<AnnualPlanOption[]>([])

  useEffect(() => {
    if (props.rcnId == null) {
      return
    }

    const fetchData = async (): Promise<void> => {
      const plans = await handleApiResponse(GetAnnualPlanOptions(props.rcnId))
      if (plans != null) setAnnualPlans(plans)
      setLoading(false)
    }

    void fetchData()
  }, [props.rcnId])

  if (loading) {
    return <CircularProgress />
  }

  return <Stack gap='24px'>
    {annualPlans?.map((planOption, index) =>
      <AnnualPlanOptionCard key={`${planOption.id}-${index}`} rcnId={props.rcnId} planOption={planOption} />)}
  </Stack>
}
